import { useState } from 'react';
import { Activity, CalendarDays, FileText, GalleryHorizontal, LayoutDashboard, Menu, Search, Settings, Stethoscope, Users } from 'lucide-react';
import { Link } from 'react-router-dom';

const items = [[LayoutDashboard,'Dashboard'],[Stethoscope,'Doctors'],[Activity,'Specialties'],[CalendarDays,'Appointments'],[GalleryHorizontal,'Media Library'],[FileText,'Blogs & SEO'],[Users,'Users'],[Settings,'Settings']];

export default function Admin() {
  const [active,setActive]=useState('Dashboard');
  const rows = [
    ['Aarav Shah','Dr. Sitaram','10:30','Confirmed'],
    ['Meera Joshi','Dr. Tejasree Goud','11:15','Pending'],
    ['Kabir Nair','Dr. B. Nagarjuna','12:00','Confirmed'],
    ['Anika Sen','Dr. Raghava Adithya','14:30','Pending']
  ];
  return <div className="admin-shell">
    <aside>
      <Link className="admin-brand" to="/"><span>✦</span> Asian Axxon <small>CMS</small></Link>
      <nav>{items.map(([Icon,label])=><button className={active===label?'active':''} onClick={()=>setActive(label)} key={label}><Icon/>{label}</button>)}</nav>
      <div className="admin-user"><span>AA</span><div><b>Asian Axxon Admin</b><small>Administrator</small></div></div>
    </aside>
    <main>
      <header><div><button className="admin-menu"><Menu/></button><h2>{active}</h2></div><label><Search/><input placeholder="Search CMS"/></label><button className="avatar">AA</button></header>
      <div className="admin-content">
        <div className="admin-welcome"><div><small>MONDAY, JULY 28</small><h1>Good evening, Admin.</h1><p>Here’s what’s happening across Asian Axxon Hospitals today.</p></div><button className="btn btn-primary">+ New appointment</button></div>
        <div className="metric-grid"><Metric title="Today's appointments" value="34" note="+8% from yesterday"/><Metric title="Active doctors" value="30" note="Multispeciality team"/><Metric title="New enquiries" value="12" note="4 need attention"/><Metric title="Published articles" value="86" note="3 scheduled"/></div>
        <div className="admin-grid">
          <section><div className="panel-head"><h3>Upcoming appointments</h3><button>View all</button></div><table><thead><tr><th>Patient</th><th>Doctor</th><th>Time</th><th>Status</th></tr></thead><tbody>{rows.map(r=><tr key={r[0]}>{r.map((c,i)=><td key={c}>{i===3?<span className={`status ${c.toLowerCase()}`}>{c}</span>:c}</td>)}</tr>)}</tbody></table></section>
          <section><div className="panel-head"><h3>Care activity</h3></div><div className="bar-chart">{[45,70,56,86,62,94,78].map((h,i)=><div key={i}><span style={{height:`${h}%`}}/><small>{['M','T','W','T','F','S','S'][i]}</small></div>)}</div></section>
        </div>
      </div>
    </main>
  </div>;
}

function Metric({title,value,note}) { return <article className="metric"><small>{title}</small><b>{value}</b><span>{note}</span></article>; }
